import React, {useState, useEffect} from "react";
import {
    AspectRatio,
    Spinner,
    Radio,
    useRadio,
    useRadioGroup,
    Select,
    Link as ChakraLink,
    HStack,
    VStack,
    Checkbox,
    useBreakpointValue,
    Container,
    Center,
    Box,
    Heading,
    Stack,
    Text,
    Divider,
    Flex,
    ListItem,
    UnorderedList,
    Badge,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    useDisclosure,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    FormControl,
    FormLabel,
    Input,
    InputRightElement,
    InputGroup,
    Button,
    Image,
    Grid,
    GridItem,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    RadioGroup,
    ListIcon,
    List,
    Icon,
} from "@chakra-ui/react";
import {ArrowUpIcon, CheckIcon} from "@chakra-ui/icons";
import {MdCheckCircle, MdVisibility, MdVisibilityOff, MdSchool} from "react-icons/md";
import {Header} from "./components/Navbar/App";
import {FooterX} from "./components/Footer/App";
import Timeline from "./components/Timeline";
import {LoremIpsum} from "react-lorem-ipsum";
import ModalBegin from "./components/Modal";
import {GoogleIcon} from "../../components/icons";
import ScrollToTop from "react-scroll-to-top";
import {useForm} from "react-hook-form";
import {
    logInWithEmailAndPassword,
    logInWithEmailAndPassword2,
    auth,
    sendPasswordReset,
    sendPasswordReset2,
    registerWithEmailAndPassword,
    // registerTest,
    // registerTestLoop
} from "../../firebase/config";
import {
    // cleanData,
    // addDataTestLoop,
    // bookingCourseListLoop,
    // checkBooking
} from '../../firestore/collection'
import {useAuthState} from "react-firebase-hooks/auth";
import {Link, useNavigate} from 'react-router-dom';
import {yearList, schoolList, branchList, articleList} from '../home/variables'
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import ShowPdf from './components/ShowPdf'
import {validatePassword} from '../../firebase/register'
import "./LandingPage.css";
import {sendPasswordResetEmail} from "firebase/auth";
import ReCAPTCHA from "react-google-recaptcha";
import { ConstructionOutlined } from "@mui/icons-material";


type DDLCenterModel = {
    text: string,
    value: string,
};

type forgotPassword = {
    email: string;
};
type signInProperty = {
    userName: string;
    password: string;
    btnSubmit: string;
};
const ContentForgotPassword = (props: any) => {
  const [email, setEmail] = useState<string>();
  const MySwal = withReactContent(Swal);
  const inputRef = React.useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<forgotPassword>();
  const onSubmit = handleSubmit(async (data: forgotPassword) => {
    // console.log(data);
    // registerWithEmailAndPassword(name, data.email, data.password, data);
    const sendMail = await sendPasswordReset2(data.email);
    if(sendMail.status) {
        MySwal.fire({
            icon:'success',
            title: sendMail.message,
            timer:3000,
        })
        props.callOnClose && props.callOnClose();
    } else {
        MySwal.fire({
            icon:'error',
            title: sendMail.message,
            timer:2000
        })
    }
    // console.log(email);
  });

    const handlerSubmit = (e: any) => {
        e.preventDefault();
        console.log(e);
    };

  return (
    <Stack direction={{ base: "column" }} spacing="4">
      <Text>กรอกอีเมล เพื่อรีเซ็ตรหัสผ่าน</Text>
      <form id="forgot-password-form" onSubmit={onSubmit}>
        <FormControl>
          <FormLabel style={{ fontWeight: "bold" }}>กรุณาระบุอีเมล</FormLabel>
          <Input
            id="forgot-password-input"
            type="email"
            placeholder="กรุณากรอกอีเมล"
            {...register("email", {
              required: "กรุณากรอก email",
              onChange: (e) => {
                setEmail(e.target.value);
              }
            })}
            // onChange={(e) => setEmail(e.target.value)}
          />
          <p style={{color:'red'}}>{errors.email?.message}</p>
        </FormControl>
      </form>
    </Stack>
  );
};

const ContentFooterForForgotPassword = (props: any) => {
    return (
        <Button type="submit" form="forgot-password-form" colorScheme="orange">
            ยืนยัน
        </Button>
    );
};

const ContentBody = (props: any) => {
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
    const [msgUserName, setMsgUserName] = useState<string>("");
    const [msgPassword, setMsgPassword] = useState<string>("");
    const [msgValidation, setMsgValidation] = useState<string>("");
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const {
        register,
        handleSubmit,
        watch,
        formState: {errors},
    } = useForm<signInProperty>();
    const alertRef = React.useRef<HTMLDivElement>(null);
    const onSubmit = handleSubmit(async (data: signInProperty) => {
        // console.log(data, "submit");
        const {userName, password} = data;
        setSubmitLoading(true);
        logInWithEmailAndPassword2(userName, password)
            .then((val) => {
                // console.log(val);
                setSubmitLoading(false);
            })
            .catch((err) => {
                const {code, message} = err;
                // console.log(err);
                if (code === "auth/invalid-email" || code === "auth/wrong-password") {
                    setMsgValidation("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
                } else if (code === "auth/user-not-found") {
                    setMsgValidation("ไม่มีผู้ใช้ในระบบ");
                }
                // console.log(code, "err-code");
                // console.log(message, "err-message");
                alertRef.current?.focus();
                setSubmitLoading(false);
            });
        // logInWithEmailAndPassword(userName, password);
        // registerWithEmailAndPassword(name, data.email, data.password, data);

        // console.log(email);
    });
    useEffect(() => {
        // console.log("component did mount");
        // if(errors.userName?.message) {
        //   setMsgUserName(errors.userName?.message);
        //   setSubmitDisabled(true);
        // } else if(errors.password?.message) {
        //   setMsgPassword(errors.password?.message);
        //   setSubmitDisabled(true);
        // } else {
        //   setSubmitDisabled(false);

        // }
    }, []);

    return (
        <Flex flexDirection={{base:'column', md:"row"}}>
            <Box w="100%" px={{base: "7"}}>
                <Flex h='100%' align={'center'} justify={'center'}>
                    <Text>
                        <Image src='./images/uniclass_logo_crop.png' w='64'/>
                    </Text>
                </Flex>
            </Box>
            <Box>
                <Divider orientation="vertical" />
            </Box>
            <Box w="100%" px={{base: "7"}}>
                <Tabs variant="enclosed" defaultIndex={1}>
                    <TabList>
                        <Tab w="100%">ลงทะเบียน</Tab>
                        <Tab w="100%">ลงชื่อเข้าใช้</Tab>
                    </TabList>

                    <TabPanels>
                        <TabPanel> {/* SignUp */}
                            <SignUpForm/>
                        </TabPanel>
                        <TabPanel> {/* SignIn */}
                            <form id="sign-in-form" onSubmit={onSubmit}>
                                <Stack spacing={2}>
                                    {msgValidation && (
                                        <Alert status="error" ref={alertRef} tabIndex={-1}>
                                            <AlertIcon/>
                                            <Flex direction={{base:'column', md:'row'}}>
                                                <AlertTitle>เข้าสู่ระบบไม่สำเร็จ</AlertTitle>
                                                <AlertDescription>{msgValidation}</AlertDescription>
                                            </Flex>
                                        </Alert>
                                    )}
                                    <FormControl>
                                        <FormLabel fontWeight={"bold"} htmlFor="userName">
                                            อีเมล์ผู้ใช้
                                        </FormLabel>
                                        <Input
                                            type="text"
                                            id="userName"
                                            {...register("userName", {
                                                required: "กรุณากรอกชื่อผู้ใช้",
                                            })}
                                            placeholder="กรุณากรอกชื่อผู้ใช้"
                                        />
                                        <Text color="red" className="text-sm">
                                            {errors.userName?.message}
                                        </Text>
                                    </FormControl>
                                    <FormControl>
                                        <FormLabel fontWeight={"bold"} htmlFor="password">
                                            รหัสผ่าน
                                        </FormLabel>
                                        <InputGroup>
                                            <Input
                                                type={!showPassword ? "password" : "text"}
                                                id="password"
                                                {...register("password", {
                                                    required: "กรุณากรอกรหัสผ่าน",
                                                })}
                                                placeholder="กรุณากรอกรหัสผ่าน"
                                            />
                                            <InputRightElement width="auto" borderRadius="16px">
                                                <Button
                                                    h="1.75rem"
                                                    size="sm"
                                                    borderRadius="10px"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    bg="transparent"
                                                >
                                                    {!showPassword ? (
                                                        <MdVisibilityOff/>
                                                    ) : (
                                                        <MdVisibility/>
                                                    )}
                                                </Button>
                                            </InputRightElement>
                                        </InputGroup>
                                        <Flex justify={"space-between"}>
                                            <Text className="text-sm" color="red">
                                                {errors.password?.message}
                                            </Text>
                                            <Text
                                                className="hover:underline text-sm cursor-pointer text-cyan-500"
                                                onClick={() => {
                                                    props.closeSignInModal && props.closeSignInModal();
                                                    props.forgotPasswordOnOpen &&
                                                    props.forgotPasswordOnOpen();
                                                }}
                                            >
                                                ลืมรหัสผ่าน
                                            </Text>
                                        </Flex>
                                    </FormControl>
                                    <Button
                                        // variant="primary"
                                        colorScheme='twitter'
                                        isLoading={submitLoading}
                                        loadingText="กำลังตรวจสอบ..."
                                        type="submit"
                                        isDisabled={submitDisabled}
                                        // onClick={() =>
                                        //   console.log(errors.userName?.message, "btnSubmit")
                                        // }
                                    >
                                        ลงชื่อเข้าใช้
                                    </Button>
                                    {props.test && 
                                    <>
                                      <Flex align="center">
                                          <Divider/>
                                          <Text padding={2} minW={"fit-content"}>
                                              หรือ
                                          </Text>
                                          <Divider/>
                                      </Flex>
                                      <Stack>
                                          <Button
                                              variant="secondary"
                                              leftIcon={<GoogleIcon boxSize="5"/>}
                                              iconSpacing="3"
                                          >
                                              เข้าสู่ระบบด้วย Google
                                          </Button>
                                      </Stack>
                                    </>
                                    }
                                </Stack>
                            </form>
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </Flex>
    );
};

const ArticleBox = (props: any) => {
}

const ContentBodyKru = (props:any) => {
    return   <AspectRatio maxW='560px' ratio={1}>
        <iframe 
        width="560" 
        height="315" 
        src={props.url && props.url}
        title="YouTube video player" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowFullScreen></iframe>
  </AspectRatio>
}

const objectKru = [
    {
        kruName: 'Peter',
        image:'./images/kru_1.jpg',
        youtubeUrl:'https://www.youtube.com/embed/sqtwKTIvFRU'
    },
    {
        kruName: 'Maxwell',
        image:'./images/kru_2.jpg',
        youtubeUrl:'https://www.youtube.com/embed/cS-yX12rW7Y'
    },
    {
        kruName: 'kru praew',
        image:'./images/kru_3.jpg',
        youtubeUrl:'https://www.youtube.com/embed/rVz1wvsZ2H0'
    },
    {
        kruName: 'kru frong',
        image:'./images/kru_4.jpg',
        youtubeUrl:'https://www.youtube.com/embed/O4MKs5sz8Vw'
    },
]

const Index = (props: any) => {
    // const { isOpen, onOpen, onClose } = useDisclosure()
    const [user, loading, error] = useAuthState(auth);
    const mdSignIn = useDisclosure();
    const mdForgotPassword = useDisclosure();
    const mdKru = useDisclosure();
    const [showButton, setShowButton] = useState(false);
    const [urlKru, setUrlKru] = useState<string>();

    useEffect(() => {
        // console.log(auth);
        const handlerScroll = () => {
            window.pageYOffset > 200 ? setShowButton(true) : setShowButton(false);
        };

        // alert(process.env.REACT_APP_VERSION)

        window.addEventListener("scroll", handlerScroll);
    }, []); // dependency | runing every time on variable change

    const scrollToTop = () => {
        // console.log("click");
        // setTimeout(() => {
        window.scrollTo({top: 0, behavior: "smooth"});
        // }, 100)
    };

    const openModalKru = (url:string) => {
        setUrlKru(url);
        mdKru.onOpen();
    }

    return (props.loading ? 
      <Box position="absolute" bg="white" w="full" h='full'>
        <Center h="100vh">
          <Spinner color="orange" size="xl" />
        </Center>
      </Box> :
        <Box w='100%'>
            <Header mdOpen={mdSignIn.onOpen} />
            <Box>
                <Container>
                    <Center>
                        <Stack>
                            {/*{ */}
                            {/*    process.env.NODE_ENV === "development" &&*/}
                            {/*    <Box>*/}
                            {/*        <Stack spacing={5} direction='column' > */}
                            {/*            <Button onClick={registerTest}>Test Add Data</Button>*/}
                            {/*            <Button onClick={addDataTestLoop}>Test Loop</Button>*/}
                            {/*            <Button onClick={bookingCourseListLoop}>BookingCourse Loop</Button>*/}
                            {/*            <Button onClick={cleanData}>clean data</Button>*/}
                            {/*            <Button onClick={() => checkBooking('PHCH')}>check booking</Button>*/}
                            {/*        </Stack>*/}
                            {/*    </Box> */}
                            {/*    }*/}
                            <Box>
                                {" "}
                                {/* box 1 */}
                                <Center className="testCarousel">
                                    <Box>
                                        <Image src='./images/main_kru2.jpg'/>
                                    </Box>
                                </Center>
                            </Box>

                            <Box className={'pt-10'}>
                                {" "}
                                {/* box 2 */}
                                <Center>
                                    <Heading as="h2" size="xl" noOfLines={3} textAlign='center'>
                                        แพลตฟอร์มเรียนภาษาอังกฤษสำหรับครูรัก(ษ์)ถิ่น
                                    </Heading>
                                </Center>
                            </Box>

                            <Box className={'pt-5'}>
                                {" "}
                                {/* box 3 */}
                                <Stack align={"center"}>
                                    <Text align={"center"}>
                                        แพลตฟอร์มการเรียนการสอนสำหรับครูรักษ์ถิ่นเพื่อพัฒนาศักยภาพของครูหรือบุคคลากรทางการศึกษา
                                    </Text>
                                    <Text align={"center"}>
                                        ให้มีทักษะกระบวนการในการสอนและเพิ่มคุณภาพการศึกษาให้ได้มาตรฐานเพื่อเพิ่มโอกาสทางการศึกษาในการเรียนรู้ภาษาอังกฤษ
                                    </Text>


                                </Stack>
                            </Box>
                            <Box pt={10}>
                                {" "}
                                <Flex flexDirection={{base: "column", sm: "row"}}>
                                    <Box w="100%">
                                        <Stack px="15px">
                                            <Center>
                                                <Image
                                                    w="100%"
                                                    h="250px"
                                                    src={"./images/img_1.png"}
                                                    alt="image1"
                                                />
                                            </Center>
                                        </Stack>
                                    </Box>
                                    <Box w="100%">
                                        <Flex
                                            justifyContent={"center"}
                                            alignItems={"center"}
                                            h="100%"
                                        >
                                            <Stack px="15px">
                                                <Text>
                                                    แพลตฟอร์มการเรียนการสอนภาษาอังกฤษสำหรับครูรักษ์ถิ่น
                                                    ที่สอนครบทุกเนื้อหาที่จำเป็นต้องใช้การการสอนภาษาอังกฤษสำหรับคุณครูครบทั้ง
                                                    4 ด้านซึ่งประกอบด้วยด้านการฟัง พูด อ่าน และ เขียน
                                                    เรียนสด(live-learning) กลุ่มละไม่เกิน 10 คน
                                                    ใช้การเรียน แบบมีส่วนร่วม(two-way communication)
                                                    ที่สนุก และไม่น่าเบื่อ
                                                </Text>
                                            </Stack>
                                        </Flex>
                                    </Box>
                                </Flex>
                            </Box>
                            <Box className={'pt-20'}>
                                {" "}
                                {/* box 6 */}
                                <Grid
                                    templateColumns={{
                                        base: "repeat(1, 1fr)",
                                        md: "repeat(4, 1fr)",
                                    }}
                                    gap={"1rem"}
                                >
                                    <GridItem w="100%">
                                        <Box px="18">
                                            <Center>
                                                <Flex bgColor='#fec627' position='relative' borderRadius={100} w='32'
                                                    h='32' justify={'center'} align='center'>
                                                    <Image w='24' h='24' src='./images/learning_icon_1.png'/>
                                                    <Box position='absolute' top='0' right='0' bgColor="green.500"
                                                        p='5px'
                                                        borderRadius={100}>
                                                        <CheckIcon color='white' w='24px' h='24px'/>
                                                    </Box>
                                                </Flex>
                                            </Center>
                                            <Center mt="3">
                                                <Text as="b" fontSize='lg'>Personalized Learning</Text>
                                            </Center>
                                            <Center mt="3">
                                                <Text>
                                                    การเรียนรู้เฉพาะบุคคล
                                                    ผู้เรียนได้มีส่วนร่วมในการกำหนดแนวทางการเรียนการสอน
                                                    ตามความถนัดหรือเป้าหมายของตนเอง
                                                </Text>
                                            </Center>
                                        </Box>
                                    </GridItem>
                                    <GridItem w="100%">
                                        <Box px="18">
                                            <Flex
                                                align={"center"}
                                                justify={"center"}
                                                flexDirection="column"
                                            >
                                                <Flex bgColor='#fec627' position='relative' borderRadius={100} w='32'
                                                    h='32' justify={'center'} align='center'>
                                                    <Image w='24' h='24' src='./images/learning_icon_2.png'/>
                                                    <Box position='absolute' top='0' right='0' bgColor="green.500"
                                                        p='5px'
                                                        borderRadius={100}>
                                                        <CheckIcon color='white' w='24px' h='24px'/>
                                                    </Box>
                                                </Flex>
                                                <Text mt="3" as="b" fontSize='lg'>
                                                    Customized Learning
                                                </Text>
                                                <Text mt="3">
                                                    เราเรียนรู้ผ่านการเรียนรู้แบบกำหนดเอง ซึ่งออกแบบมาสำหรับน้อง ๆ
                                                </Text>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem w="100%" px="18">
                                        <Flex align="center" justify="center" direction="column">
                                            <Flex bgColor='#fec627' position='relative' borderRadius={100} w='32' h='32'
                                                justify={'center'} align='center'>
                                                <Image w='24' h='24' src='./images/learning_icon_3.png'/>
                                                <Box position='absolute' top='0' right='0' bgColor="green.500" p='5px'
                                                    borderRadius={100}>
                                                    <CheckIcon color='white' w='24px' h='24px'/>
                                                </Box>
                                            </Flex>
                                            <Text mt="3" as="b" fontSize='lg'>
                                                Active Learning
                                            </Text>
                                            <Text mt="3">
                                                เปิดโอกาสให้ผู้เรียนได้ใช้กระบวนการคิด วิเคราะห์ และลงมือทำด้วยตัวเอง
                                            </Text>
                                        </Flex>
                                    </GridItem>
                                    <GridItem w="100%">
                                        {/* <Flex align='center' justify='center' direction='column'> */}
                                        <Stack
                                            direction="column"
                                            spacing={3}
                                            align="center"
                                            px="18"
                                        >
                                            <Flex bgColor='#fec627' position='relative' borderRadius={100} w='32' h='32'
                                                justify={'center'} align='center'>
                                                <Image w='24' h='24' src='./images/learning_icon_4.png'/>
                                                <Box position='absolute' top='0' right='0' bgColor="green.500" p='5px'
                                                    borderRadius={100}>
                                                    <CheckIcon color='white' w='24px' h='24px'/>
                                                </Box>
                                            </Flex>
                                            <Text mt="3" as="b" fontSize='lg'>
                                                Live Learning
                                            </Text>
                                            <Text mt="3" fontSize='md'>
                                                เรียนออนไลน์ผ่านแพลตฟอร์ม เนื้อหาเรียน ประกอบด้วย ข้อความ, รูปภาพ,
                                                เสียง, VDO น้อง ๆ สามารถโต้ตอบกับเพื่อนร่วมชั้น หรือสนทนาถามตอบกับครูได้
                                            </Text>
                                        </Stack>
                                        {/* </Flex> */}
                                    </GridItem>
                                </Grid>
                            </Box>

                            {
                                process.env.REACT_APP_MODE === 'PROD' &&
                                <Box id="booking-course" pt={'10'}>
                               {" "}
                               {/* /!* box 7 *!/ */}
                               <Center>
                                   <Button type="button" p="8" colorScheme="twitter" onClick={mdSignIn.onOpen} m="2"
                                           className={'transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110 duration-300'}>
                                       <Heading color="white">
                                           จองคอร์สเรียน
                                       </Heading>
                                   </Button>
                               </Center>
                            </Box>}
                            <Box pt={10}>
                                {" "}
                                {/* box 8 */}
                                <Flex flexDirection={{base: "column", md: "row"}}>
                                    <Box w="100%">
                                        <Stack
                                            direction={"column"}
                                            spacing={4}
                                            align="center"
                                            px="6"
                                            py={{base: "5", md: "0"}}
                                        >
                                            <Image src={"./images/img_2.png"} w="250px" alt="img2"/>
                                            <Image src={"./images/img_3.png"} w="250px" alt="img3"/>
                                        </Stack>
                                    </Box>
                                    <Box w="100%">
                                        <Stack px="6" py={{base: "5", md: "0"}}>
                                            <List spacing={6}>
                                                <ListItem verticalAlign={'top'}>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>เรียนสด กลุ่มเล็ก ไม่เกิน 10 คน</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>ครั้งละ 40 นาที</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>เรียนสดผ่านโปรแกรม Zoom</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>

                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text> สอนสดโดยครูต่างชาติ และครูไทยที่มีประสบการณ์สอนสูง</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>ได้รับแพลตฟอร์มเว็บไซต์สำ หรับครูรักษ์ถิ่นโดยเฉพาะ</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>มีระบบประเมินผลรายบุคคล ฟีดแบคทันทีหลังคาบเรียน</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>พร้อมส่งผลการประเมินถึงมหาวิทยาลัย</Text>
                                                    </HStack>
                                                </ListItem>
                                            </List>
                                        </Stack>
                                    </Box>
                                </Flex>
                            </Box>
                            <Box pt={'16'}>
                                {" "}
                                {/*box 9*/}
                                {/*<Badge colorScheme="yellow" variant="subtle">*/}
                                {/*    <Heading as="h2" size="xl" padding="3">*/}
                                {/*        MODULE (Course Outline)*/}
                                {/*    </Heading>*/}
                                {/*</Badge>*/}
                                <Box borderRadius="md" display="inline-block">
                                    <Heading as="h3" size="lg" padding="3">
                                        MODULE (Course Outline)
                                    </Heading>
                                </Box>
                            </Box>
                            <Box>
                                {" "}
                                {/* box 10 */}
                                <Flex direction={{base: "column", md: "row"}}>
                                    <Box w="100%" px="6">
                                        <Stack spacing={6}>
                                            <Text>
                                                Group Class with 40 minutes Speaking & Listening Skills
                                                เรียนกับครูต่างชาติ Certified Coaches Reading & Writing
                                                Skills เรียนกับครูไทยประสบการณ์สอนสูง
                                            </Text>
                                            <List spacing={3}>
                                                {/*<ListItem>*/}
                                                {/*    <Text>Speaking 10 คาบ</Text>*/}
                                                {/*</ListItem>*/}
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdSchool} color='green.500' fontSize={'xl'}/>
                                                        <Text>Speaking 10 คาบ</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdSchool} color='green.500' fontSize={'xl'}/>
                                                        <Text>Listening 10 คาบ</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdSchool} color='green.500' fontSize={'xl'}/>
                                                        <Text>Reading 10 คาบ</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdSchool} color='green.500' fontSize={'xl'}/>
                                                        <Text>Writing 10 คาบ</Text>
                                                    </HStack>
                                                </ListItem>
                                            </List>
                                            <Text>
                                                หลังจากเรียนสดจบแล้ว สามารถเรียนผ่าน Video clip based
                                                ได้ไม่จำ กัดนวนครั้ง (unlimited) อายุ 1 ปีเต็ม
                                            </Text>
                                        </Stack>
                                    </Box>
                                    <Box w="100%" px="6">
                                        <Center>
                                            <Image
                                                src={"./images/img_4.jpg"}
                                                width="75%"
                                                alt="img4"
                                            />
                                        </Center>
                                    </Box>
                                </Flex>
                            </Box>
                            <Box pt={10}>
                                {" "}
                                {/* box 11 */}
                                {/*<Badge colorScheme={"yellow"}>*/}
                                {/*    <Heading as="h2" size="xl" padding="3">*/}
                                {/*        ไม่มีพื้นฐานก็เก่งได้*/}
                                {/*    </Heading>*/}
                                {/*</Badge>*/}
                                <Box borderRadius="md" display="inline-block">
                                    <Heading as="h2" size="lg" padding="3">
                                        ไม่มีพื้นฐานก็เก่งได้
                                    </Heading>
                                </Box>
                            </Box>
                            <Box>
                                {" "}
                                {/* box 10 */}
                                <Flex direction={{base: "column", md: "row"}}>
                                    <Box w="100%" px="6">
                                        <Stack spacing={6}>
                                            <Text>
                                                เราเริ่มปูพื้นฐานให้ใหม่
                                                เรียนสดออนไลน์กับคุณครูเจ้าของภาษาในคลาส Workshop ทั้ง
                                                ไวยากรณ์ การพูด เขียน และคำศัพท์ใหม่ๆ ทั้งในชีวิตประจำวันและ
                                                การทำงานที่หลากหลาย
                                                พร้อมเอกสารประกอบการเรียนภาษาอังกฤษและวีดีโอ ลิขสิทธิ์เฉพาะ
                                                Uniclassและแบบฝึกหัด ซึ่งจะทำให้ผู้เรียนพัฒนาภาษาอังกฤษได้เร็ว
                                                ยิ่งขึ้น
                                            </Text>
                                        </Stack>
                                    </Box>
                                </Flex>
                            </Box>
                            
                            <Box
                                p={8}
                                width="full"
                                // borderWidth="1px"
                                // borderRadius="lg"
                                overflow="hidden"
                                // bgColor={"lightblue"}
                                // paddingBottom={7}
                            >
                                {" "}
                                {/* box 13 */}
                                <Flex flexDirection={{base: "column", md: "row"}}>
                                    <Box w="100%" px="7">
                                        <Center>
                                            <Image
                                                src={"./images/img_5.png"}
                                                borderRadius="50%"
                                                width="80%"
                                                alt="img5"
                                            />
                                        </Center>
                                    </Box>
                                    <Box w="100%" px="7">
                                        <Flex align="center" h="100%" justify="left">

                                            <List spacing={6}>
                                                <ListItem verticalAlign={'top'}>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>มีเอกสารประกอบการเรียน</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>สามารถสอบถามได้</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>นำไปใช้ในชีวิตประจำวันได้จริง</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>

                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>รับรองผลการเรียนดีขึ้น</Text>
                                                    </HStack>
                                                </ListItem>
                                                <ListItem>
                                                    <HStack>
                                                        <ListIcon as={MdCheckCircle} color='green.500' fontSize={'xl'}/>
                                                        <Text>กำหนดเป้าหมายการเรียนชัดเจน</Text>
                                                    </HStack>
                                                </ListItem>
                                            </List>
                                            {/*<UnorderedList spacing={6}>*/}
                                            {/*    <ListItem>มีเอกสารประกอบการเรียน</ListItem>*/}
                                            {/*    <ListItem>สามารถสอบถามได้</ListItem>*/}
                                            {/*    <ListItem>นำไปใช้ในชีวิตประจำวันได้จริง</ListItem>*/}
                                            {/*    <ListItem>รับรองผลการเรียนดีขึ้น</ListItem>*/}
                                            {/*    <ListItem>กำหนดเป้าหมายการเรียนชัดเจน</ListItem>*/}
                                            {/*</UnorderedList>*/}
                                        </Flex>
                                    </Box>
                                </Flex>
                            </Box>

                            <Box id='teacher'>
                                <Stack spacing='3'>
                                    <Heading>คุณครู</Heading>
                                    <Box>
                                        <Grid templateColumns={{base:'repeat(1, 1fr)', md:"repeat(2, 1fr)"}} gap={6}>
                                            {objectKru && 
                                            objectKru.map((val:any, idx:number) => {
                                                return  <GridItem key={idx} w='100%' h='auto' bg='lightblue' boxShadow={'md'} borderRadius='5'>
                                                <Box>
                                                    <Image src={val.image} w='auto' h='auto' />
                                                    <Box cursor={'pointer'} onClick={() => openModalKru(val.youtubeUrl)} p='3'>
                                                        <Center>
                                                            <Text>วีดีโอแนะนำคุณครู</Text>
                                                        </Center>
                                                    </Box>
                                                </Box>
                                            </GridItem>
                                            })
                                            }
                                        </Grid>
                                    </Box>
                                </Stack>
                            </Box>
                            
                            <Box id='how-to-use' pt={10}>
                                {" "}
                                {/* box 14 */}
                                <Divider borderColor={"twitter.500"} borderWidth={2}/>
                                <Heading size="2xl" textAlign={"center"} py="7">
                                    คู่มือการใช้งาน
                                </Heading>
                                <Divider borderColor={"twitter.500"}/>
                            </Box>
                            <Box pt={2}>
                                {" "}
                                {/* box 15 Timeline */}
                                <Timeline/>
                            </Box>
                            
                            <Box>
                                <Stack id='article' spacing='3' pt={10}>
                                    <Heading> บทความ </Heading>
                                    <Grid templateColumns={{base:'repeat(2, 1fr)', md:'repeat(5, 1fr)'}} gap={6} pt={4}>
                                        {
                                            articleList &&
                                            articleList.map((val: any, idx: number) => {
                                                return (
                                                    <GridItem key={idx} w='100%' bg='white' minH='100px' boxShadow={'md'}
                                                            borderRadius='10'
                                                            id={'article' + val.id}
                                                            >
                                                        <Link to={`article/${val.id}`}>
                                                            <Flex px='5' w='auto' h='100%' justify='center' align='center'
                                                                borderRadius='10' transition={".2s ease-in-out"} _hover={{
                                                                // backgroundColor: 'lightblue',
                                                                backgroundColor: 'twitter.400',
                                                                borderRadius: '10',
                                                                fontSize: 'lg'
                                                            }}>
                                                                {val.title}

                                                            </Flex>
                                                        </Link>
                                                    </GridItem>
                                                    // <Link to={`article/${val.id}`}>{val.title}</Link>
                                                )
                                            })
                                        }
                                    </Grid>

                                </Stack>
                            </Box>

                            <Box paddingBottom={4} id='question' pt={10}>
                                {" "}
                                {/* box 16 */}
                                <Stack spacing='3' direction={"column"}>
                                    <Box w="100%">
                                        <Heading> คำถามที่พบบ่อย ?</Heading>
                                    </Box>
                                    <Box w="100%" pt={2}>
                                        <Accordion allowToggle>
                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton>
                                                        <Box as="span" flex="1" textAlign="left">
                                                            <Text>เรียนกับเรามีค่าใช้จ่ายหรือไม่ ?</Text>
                                                        </Box>
                                                        <AccordionIcon/>
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>
                                                    <Text>
                                                        แพลตฟอร์มของเราเป็นการเรียนในรูปแบบออนไลน์ ไม่มีค่าใช้จ่ายใด ๆ
                                                        ไม่มีค่าธรรมเนียมการสมัคร น้อง ๆ สามารถลงทะเบียนเรียนได้ฟรี
                                                        แม้ว่าการเรียนผ่านช่องทางออนไลน์จะเป็นเรื่องใหม่
                                                        แต่เราได้ทุ่มเทสร้างสรรค์การเรียนการสอนบนช่องทางออนไลน์ขึ้นเพื่อให้แน่ใจว่าผู้เรียนจะได้รับประสบการณ์
                                                        การเรียนรู้แบบไม่มีสะดุด
                                                        ผ่านการใช้งานแพลตฟอร์มอันแสนง่ายดายและมีประสิทธิภาพ
                                                    </Text>
                                                </AccordionPanel>
                                            </AccordionItem>

                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton>
                                                        <Box as="span" flex="1" textAlign="left">
                                                            <Text>เมื่อลงทะเบียนแล้ว
                                                                จะสามารถเข้าเรียนได้ถึงเมื่อไหร่ มีกำหนดวันหรือไม่
                                                                ?</Text>
                                                        </Box>
                                                        <AccordionIcon/>
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>
                                                    <Text>
                                                        เมื่อลงทะเบียนเรียนเสร็จเรียบร้อย
                                                        น้องๆสามารถเรียนสดได้ตามตารางที่กำหนดไว้ได้ตามวันและเวลาที่สะดวก
                                                        พร้อมทั้งทีมงานผู้เชี่ยวชาญที่พร้อมให้คำแนะนำบนแพลตฟอร์มก่อนเข้าคลาสเรียนเพื่อให้เกิดความราบรื่น
                                                        นอกจากนี้น้อง ๆ
                                                        สามารถเรียนย้อนหลังได้จากคลิปวีดีโอการสอนที่บันทึกไว้ได้ไม่จำกัดจำนวนครั้งเพื่อประสิทธิภาพในการเรียนรู้อย่างสูงสุด
                                                    </Text>
                                                </AccordionPanel>
                                            </AccordionItem>

                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton>
                                                        <Box as="span" flex="1" textAlign="left">
                                                            <Text>มีวิชาเกี่ยวกับอะไรบ้าง ?</Text>
                                                        </Box>
                                                        <AccordionIcon/>
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>
                                                    <Text>
                                                        มีการเรียนการสอนภาษาอังกฤษทั้ง 4 ทักษะ เช่นการฟัง การพูด การอ่าน
                                                        และการเขียน
                                                        นอกจากนี้น้อง ๆ จะได้เรียนภาษาอังกฤษกับเจ้าของภาษาโดยตรง
                                                        เพราะเราเชื่อว่าการมอบประสบการณ์การเรียนที่มีคุณภาพ
                                                        และการจัดสภาพแวดล้อมการเรียนรู้ที่เอื้อต่อนักเรียนเป็นสิ่งสำคัญ
                                                        จึงมีทั้งที่ปรึกษาหลักสูตร ปรึกษาการเรียน คุณครู
                                                        และผู้เชี่ยวชาญด้านปฏิบัติการ
                                                        คอยดูแลเพื่อสร้างประสบการณ์การเรียนรู้ที่ยอดเยี่ยมให้กับน้อง ๆ
                                                    </Text>
                                                </AccordionPanel>
                                            </AccordionItem>

                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton>
                                                        <Box as="span" flex="1" textAlign="left">
                                                            <Text>หากมีข้อสงสัยเพิ่มเติมจะสามารถติดต่อสอบถามได้ที่ไหน
                                                                ?</Text>
                                                        </Box>
                                                        <AccordionIcon/>
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>
                                                    <Text>
                                                        หากน้อง ๆ มีคำถามหรือข้อสงสัยในเรื่องการเรียน
                                                        รวมถึงปัญหาการลงทะเบียนเรียน สามารถติดต่อเราได้ทันที
                                                        เราจะตอบสนองความต้องการและจัดการปัญหาที่เกิดขึ้นอย่างเร็วที่สุด
                                                        รวมถึงน้อง ๆ สามารถแสดงความคิดเห็นและให้คำแนะนำกับเราได้
                                                        โดยติดต่อเราได้ที่ line: @uniclass หรือโทร 091-782-4562
                                                    </Text>
                                                </AccordionPanel>
                                            </AccordionItem>
                                        </Accordion>
                                    </Box>
                                </Stack>
                            </Box>
                        </Stack>
                    </Center>
                </Container>
            <ModalBegin
                isOpen={mdSignIn.isOpen}
                onOpen={mdSignIn.onOpen}
                onClose={mdSignIn.onClose}
                size={{base:'sm', md:'6xl'}}
                contentBody={
                    <ContentBody
                        forgotPasswordOnOpen={mdForgotPassword.onOpen}
                        closeSignInModal={mdSignIn.onClose}
                    />
                }
            />

            {/* Modal ForgotPassword */}
            <ModalBegin
                isOpen={mdForgotPassword.isOpen}
                onOpen={mdForgotPassword.onOpen}
                onClose={mdForgotPassword.onClose}
                size={"xl"}
                Title="ลืมรหัสผ่าน"
                closeOnOverlayClick={false}
                contentBody={<ContentForgotPassword callOnClose={mdForgotPassword.onClose}/>}
                contentFooter={<ContentFooterForForgotPassword/>}
            />
                <ModalBegin
                    isOpen={mdKru.isOpen}
                    onOpen={mdKru.onOpen}
                    onClose={mdKru.onClose}
                    size={"xl"}
                    contentBody={<ContentBodyKru url={urlKru} />}
                    
                />
            </Box>

            {/* <SectionBody 
                mdSignIn={mdSignIn} 
                mdForgotPassword={mdForgotPassword} 
                showButton={showButton} 
                scrollToTop={scrollToTop} 
            /> */}


            {showButton && (
                // <div
                //     className="fixed bottom-7 right-7 cursor-pointer hover:bg-red-500 bg-blue-400 shadow-red-500 rounded-md ease-in-out duration-200 btnScrollToTop"
                //     onClick={scrollToTop}
                // >
                <div
                    className="fixed bottom-7 right-7 cursor-pointer bg-sky-400 hover:bg-sky-200 rounded-full ease-in-out duration-200 btnScrollToTop"
                    onClick={scrollToTop}
                >
                    <Icon as={ArrowUpIcon} color={'gray.50'} className={'hover:text-gray-700'} boxSize={"40px"}/>
                </div>
            )}
            <FooterX/>
        </Box>
    );
};


type FormValues = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    phone: string;
    school: string;
    branch: string;
    year: string;
    role: boolean;
    offerPromotion: boolean;
    type: string;
    credit: number;
}

const ContentBodyAgreement = (props:any) => {
    return <Stack spacing={4}>
        <Box>
            <Text fontWeight={'bold'}>ข้อตกลงการใช้งาน</Text>
            <Text>
                แพลตฟอร์มเรียนภาษาอังกฤษสำหรับครูรัก(ษ์)ถิ่น อยู่ภายใต้การดูแลของ บริษัท สเปซบี จำกัด ซึ่งต่อไปในนี้จะเรียกว่า “บริษัท” โดยแพลตฟอร์มนี้เป็นตัวกลางในการเรียนภาษาอังกฤษออนไลน์ ซึ่งอยู่ภายใต้ข้อกำหนดและเงื่อนไขนี้
                บริษัท เป็นเจ้าของและผู้มีอำนาจแต่เพียงผู้เดียวในการจัดการเรื่องการใช้งานแพลตฟอร์มนี้ ทั้งนี้การใช้แพลตฟอร์มของท่านต้องอยู่ภายใต้ข้อตกลงและเงื่อนไขดังมีรายละเอียดต่อไปนี้ ซึ่งท่านควรอ่านอย่างละเอียด การใช้แพลตฟอร์มหรือเข้าไปดูข้อมูลในหน้าใดๆ ถือว่าท่านยอมรับข้อผูกพันที่ระบุไว้ในข้อตกลงและเงื่อนไขการใช้แพลตฟอร์มนี้ อนึ่ง ในข้อตกลงและเงื่อนไขนี้ คำว่า “พวกเรา” “เรา” จะหมายความถึง บริษัท จำกัด และ/หรือแพลตฟอร์ม และคำว่า “ท่าน” และ “ของท่าน” จะหมายความถึง นักศึกษาที่เข้าใช้แพลตฟอร์มนี้
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>1.การตกลงยินยอมที่จะปฏิบัติตามข้อตกลงและเงื่อนไขการใช้นี้</Text>
            <Text>
                การเข้าใช้แพลตฟอร์มนี้อยู่ภายใต้ข้อตกลงและเงื่อนไขซึ่งใช้บังคับอยู่ และซึ่งอาจมีการแก้ไข หรือปรับปรุง ขอให้ท่านกรุณาอ่านเงื่อนไขการใช้งานดังกล่าวด้วยความระมัดระวังก่อนที่จะเข้าใช้แพลตฟอร์ม ทั้งนี้ โดยการที่ท่านเข้าใช้แพลตฟอร์มนี้แสดงว่าท่านยินยอมผูกพันตนตามข้อตกลงและเงื่อนไข ตามที่ปรากฏนี้หรือตามที่จะได้มีการแก้ไขหรือปรับปรุงในอนาคต และหมายความรวมไปถึงว่าท่านเข้าใจและเห็นชอบกับข้อตกลงดังกล่าวด้วย ด้วยหากว่าหลังจากที่ท่านได้อ่านข้อตกลงและเงื่อนไขการใช้งานดังกล่าวแล้ว ท่านไม่ยินยอมและไม่เห็นชอบด้วยกับข้อตกลงและเงื่อนไขนั้นขอให้ท่านยุติการใช้แพลตฟอร์มโดยทันที ท่านสามารถอัพเดทข้อมูลส่วนบุคคลได้ตลอดเวลา เพียงลงทะเบียนเข้าสู่ระบบสมาชิกของท่าน ทั้งนี้ทางแพลตฟอร์มแนะนำให้ท่านเก็บข้อมูลทางบัญชีเป็นความลับ หากท่านมอบ หรืออนุญาตให้บุคคลอื่นนำข้อมูลส่วนบุคคล และ/หรือ ชื่อบัญชีผู้ใช้งานดังกล่าวไปใช้การใดๆ ท่านยอมรับและถือว่าการกระทำเหล่านั้นเป็นการกระทำโดยตัวของท่านเองและถือว่ามีผลผูกพันกับท่านตามกฎหมาย ทั้งนี้ทางบริษัทขอสงวนสิทธิ์ไม่รับผิดชอบในความเสียหายใดๆที่เกิดขึ้นจากการเข้าสู่ระบบบนแพลตฟอร์มด้วยชื่อบัญชีผู้ใช้งานและรหัสของท่าน แม้ท่านจะมิได้เป็นผู้ดำเนินการเอง
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>2.ทรัพย์สินทางปัญญา</Text>
            <Text>
                2.1 เครื่องหมายการค้าและลิขสิทธิ์
                บริษัท สเปซบี จำกัด เป็นเจ้าของลิขสิทธิ์ข้อมูล เครื่องหมายการค้า สัญลักษณ์  และชื่อทางการค้า และส่วนประกอบอื่นๆ ที่ปรากฏบนทุกๆ หน้าของเว็บไซต์นี้ บริษัทไม่อนุญาตหรือยินยอมให้บุคคลใด กระทำการใดๆเกี่ยวกับ ข้อมูล เครื่องหมายการค้า สัญลักษณ์ และชื่อทางการค้า และส่วนประกอบอื่นๆนั้นๆอันเป็นการดัดแปลง จัดเก็บในระบบที่สามารถนำมาใช้งานได้ ถ่ายโอน ลอกเลียนแบบ เผยแพร่ หรือใช้ข้อมูลและส่วนประกอบนั้นโดยวิธีอื่นใด เพื่อวัตถุประสงค์ทางการค้า โดยมิได้รับความยินยอมล่วงหน้าเป็นลายลักษณ์อักษรจาก บริษัท อย่างเด็ดขาด
                <br />
                2.2 การจำกัดการใช้งาน
                ท่านจะไม่กระทำการและท่านตกลงที่จะไม่ทำให้ผู้อื่นกระทำการลอกเลียน(เว้นแต่จะได้รับอนุญาตโดยการให้ใช้สิทธิ์นี้อย่างชัดแจ้ง) กระจาย ทำวิศวกรรมย้อนกลับ (วิศวกรรมย้อนกลับ คือ กระบวนการค้นหาโครงสร้าง ฟังก์ชันการทำงาน ซึ่งเกี่ยวข้องกับการแยกชิ้นส่วนของโปรแกรมออกจากกัน แล้ววิเคราะห์การทำงานในแต่ละส่วน จากนั้นจึงนำมาสร้างโปรแกรมใหม่ ที่ทำงานได้เหมือนเดิม โดยปราศจากการคัดลอกจากต้นแบบ) แยกประกอบ หรือพยายามที่จะดึงรหัสข้อมูล หรือถอดรหัส หรือแก้ไข หรือสร้างงานอนุพันธุ์ของแพลตฟอร์มหรือการบริการใดๆ ที่ เราจัดให้ หรือส่วนใดๆ ของแพลตฟอร์ม                
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>3.การจำกัดความรับผิดชอบและความรับผิดของเรา</Text>
            <Text>
                3.1 การไม่รับรองหรือรับประกัน
                แพลตฟอร์ม และเอกสารข้อมูล ให้บริการในหลักเกณฑ์ “ตามที่เป็น” และ “ตามที่มี” ข้อมูลและ/หรือข้อสนเทศทั้งหลายที่อยู่ในแพลตฟอร์ม บริการ หรือเอกสารข้อมูล ถูกให้ไว้เพื่อใช้เป็นข้อมูลเท่านั้น ไม่มีการรับรองหรือรับประกันอย่างใด ๆ ไม่ว่าโดยปริยาย ชัดแจ้งหรือโดยบทบัญญัติใด ๆ รวมทั้งการรับประกันการไม่ละเมิดสิทธิของบุคคลภายนอก กรรมสิทธิ์ ความสามารถในการนำไปค้าขายได้ คุณภาพที่เป็นที่พอใจ หรือความเหมาะสมต่อวัตถุประสงค์อย่างหนึ่งอย่างใด ให้ไว้ในส่วนที่เกี่ยวข้องกับแพลตฟอร์ม หรือเอกสารข้อมูล โดยไม่เป็นการกระทบกระเทือนต่อผลบังคับของที่กล่าวมาก่อนหน้า เราไม่รับประกัน: 
                <br />
                (ก) ความถูกต้อง เหมาะแก่เวลา ความพอเพียง มูลค่าในทางพาณิชย์ หรือความครบถ้วนของข้อมูล และ/หรือข้อสนเทศทั้งหลายที่อยู่ในแพลตฟอร์ม หรือเอกสารข้อมูล 
                <br />
                (ข) ว่าแพลตฟอร์ม  หรือเอกสารข้อมูลใด ๆ จะมีให้โดยไม่เกิดการติดขัด มีความมั่นคง หรือปราศจากความผิดพลาดหรือตกหล่น หรือข้อชำรุดบกพร่องใด ๆ ที่ระบุได้จะได้รับการแก้ไข 
                <br />
                (ค) ว่าแพลตฟอร์ม หรือเอกสารข้อมูล ปราศจากไวรัสคอมพิวเตอร์หรือ รหัสที่ทำขึ้นด้วยเจตนาร้าย รหัสที่ทำให้เกิดการทำลาย หรือรหัสที่ทำให้เกิดการขัดข้อง โปรแกรมตัวแทน หรือกลุ่มคำสั่ง หรือมาโครอื่นใดที่เป็นอันตราย ก่อความเสียหาย หรือทำให้เกิดการขัดข้อง และ
                <br />
                (ง) ความปลอดภัยในข้อมูลใด ๆ ที่ส่งโดยท่านหรือไปยังท่านผ่านทางแพลตฟอร์ม และท่านยอมรับความเสี่ยงว่าข้อมูลใด ๆ ที่ส่งหรือได้รับผ่านทางบริการหรือแพลตฟอร์มอาจจะถูกเข้าถึงโดยบุคคลภายนอกที่ไม่ได้รับอนุญาตได้ และ/หรือเปิดเผยโดยฝ่ายเราหรือเจ้าหน้าที่ ลูกจ้าง หรือตัวแทนของเราให้แก่บุคคลภายนอกที่อ้างว่าเป็นท่านหรืออ้างว่ากระทำการโดยได้รับมอบอำนาจจากท่าน การส่งข้อมูลทางอินเทอร์เน็ตและไปรษณีย์อิเล็กทรอนิกส์อาจจะถูกขัดขวาง ขาดการติดต่อ ล่าช้า จากความแออัดในการส่งข้อมูลทางอินเทอร์เน็ตหรือมีการส่งข้อมูลไม่ถูกต้องเนื่องจากลักษณะของอินเทอร์เน็ตที่อาจถูกเปิดเผยต่อสาธารณะได้
                <br />
                3.2 การยกเว้นความรับผิด
                <br />
                เราไม่ต้องรับผิดต่อท่านในการสูญเสียใด ๆ ก็ตามหรือไม่ว่าเกิดขึ้นอย่างไรก็ตาม (โดยไม่คำนึงถึงรูปแบบการกระทำ) อันเกิดขึ้นโดยตรงหรือโดยอ้อมเกี่ยวข้องกับ: (ก) การเข้าใช้ ใช้งาน และ/หรือการไม่สามารถใช้แพลตฟอร์ม หรือบริการได้
                <br />
                (ข) การเชื่อถือข้อมูลหรือข้อสนเทศใด ๆ ที่มีอยู่ในแพลตฟอร์ม ท่านไม่ควรกระทำการใดกับข้อมูลหรือข้อสนเทศดังกล่าวโดยไม่ได้ตรวจสอบความถูกต้องของเนื้อหาด้วยตนเองเสียก่อน (ค) ระบบ เซิร์ฟเวอร์ หรือการเชื่อมต่อใด ๆ เกิดการล้มเหลว ผิดพลาด ตกหล่น ขัดข้อง ล่าช้า มีไวรัสคอมพิวเตอร์หรือการปองร้ายอื่นๆ การทำลาย หรือ รหัสที่ทำให้เกิดการขัดข้อง โปรแกรมตัวแทน หรือกลุ่มคำสั่ง หรือมาโครอื่นใด ที่เป็นอันตราย ก่อความเสียหาย หรือทำให้เกิดความผิดพลาด
                <br />
                3.3 ด้วยความเสี่ยงภัยของท่านเอง
                <br />
                ความเสี่ยงจากการเข้าใจผิด ความผิดพลาด ความเสียหาย ค่าใช้จ่าย หรือการสูญเสียใด ๆ อันเป็นผลจากการใช้แพลตฟอร์มนั้นเป็นความเสี่ยงภัยของท่านเองทั้งสิ้น และเราจะไม่ต้องรับผิดใด ๆ ในกรณีดังกล่าว
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>4.กฎหมายที่ใช้บังคับ</Text>
            <Text>สาระและประเด็นทั้งหมดที่เกี่ยวข้องกับการใช้ โดยรวมถึงการปฏิบัติตามและการตีความเพื่อการปฏิบัติตามข้อตกลงและเงื่อนไขการใช้งานทั้งหลายเหล่านี้นั้นให้อยู่ภายใต้กฎหมายไทย ที่บังคับใช้อยู่ในเรื่องนั้นๆ ของประเทศไทย</Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>5.การยุติข้อพิพาท</Text>
            <Text>
                ข้อพิพาทใดๆ ที่เกิดขึ้นจากข้อกำหนด การใช้ หรือที่เกี่ยวข้องกับการใช้เว็บไซต์ ซึ่งไม่สามารถหาข้อยุติได้โดยการเจรจา โดยสุจริตหรือการไกล่เกลี่ยแล้ว ให้ยุติข้อพิพาททางศาล
            </Text>
        </Box>

        <Box>
            <Text fontWeight={'bold'}>6.วัตถุประสงค์ของการเข้าใช้งาน</Text>
            <Text>
                แพลตฟอร์มนี้เป็นเว็บไซต์เพื่อการเรียนรู้ภาษาอังกฤษสำหรับนักศึกษาในโครงการครูรัก(ษ์)ถิ่น ดังนั้นจึงมิได้มุ่งหวังให้บุคคลภายนอกเข้าใช้งานทั้งนี้ให้ถือว่าวันที่ท่านได้ทำการยอมรับข้อตกลงและเงื่อนไขการใช้งานของเราแล้วนั้น ให้ถือเป็นการยินยอมแล้วโดยปริยาย
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>7.การไม่ใช้ในทางที่ผิดกฎหมายหรือต้องห้ามตามกฎหมาย</Text>
            <Text>
            ในการใช้แพลตฟอร์มนี้ ท่านต้องปฏิบัติตามกฎหมาย หลักการ คำสั่ง และกฎเกี่ยวกับการใช้ของท่านในการบริการของเราและการดำเนินการใดที่เกี่ยวข้อง นอกจากนี้ ท่านรับรองว่าท่านจะไม่ใช้แพลตฟอร์มนี้เพื่อวัตถุประสงค์ใดๆ ที่ผิดกฎหมาย หรือต้องห้ามตามกฎหมาย หรือโดยข้อกำหนด เงื่อนไข และประกาศของหน่วยงานราชการที่เกี่ยวข้อง นอกจากนี้ ท่านตกลงว่า
            <br />
            7.1 ท่านจะไม่อัพโหลด โพสต์ข้อความ ส่งอีเมล จดหมายลูกโซ่หรือทำการส่งโดยประการใด ซึ่งมีเนื้อหาหรือข้อความที่ผิดกฎหมาย ใน ลักษณะที่เป็นอันตราย ข่มขู่ กล่าวร้าย รบกวนใจละเมิดสิทธิผู้อื่นหรือเป็นการดูหมิ่น หมิ่นประมาท หยาบคาย ลามกอนาจาร หรือเป็นการละเมิดซึ่งข้อมูลที่เป็นความลับ ก่อให้เกิด ความน่ารังเกียจ หรือเหยียดหยามเชื้อชาติชาติพันธุ์หรือศาสนาของผู้อื่นหรือกระทบความมั่นคงของสถาบันชาติ ศาสนา และพระมหากษัตริย์ หรือทำการโดยประการอื่นใดในลักษณะดังกล่าว
            <br />
            7.2 ท่านจะไม่อัพโหลด โพสต์ข้อความ ส่งอีเมล หรือส่งโดยประการอื่นใดซึ่งเนื้อหาใดๆที่มีซอฟท์แวร์ไวรัส หรือรหัสคอมพิวเตอร์อื่นใด ไฟล์ หรือโปรแกรมที่ออกแบบ เพื่อขัดขวางทำลาย หรือจำกัดการทำงานของซอฟท์แวร์คอมพิวเตอร์หรือฮาร์ทแวร์หรืออุปกรณ์สื่อสารใดๆ
            <br />
            7.3 ท่านจะไม่สะสมหรือเก็บข้อมูลส่วนตัวของผู้ใช้รายอื่น
            <br />
            7.4 ท่านจะไม่แทรกแซงหรือก่อให้เกิดความยุ่งยากต่อบริการ หรือเครือข่ายที่ต่อไปยังบริการ หรือขัดขืนต่อข้อกำหนด กระบวนการ นโยบาย หรือ กฎใดๆของเครือข่ายที่ต่อไปยังบริการ
            <br />
            7.5ท่านจะไม่นำซอฟต์แวร์ของ เราไปใช้เป็นทรัพย์สินส่วนบุคคล หรือ โอนถ่ายให้บุคคลที่สาม จำหน่าย จ่าย แจก ให้เช่า ไม่ว่าทั้งหมดหรือบางส่วนก็ตาม
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>8.การยินยอมให้เผยแพร่</Text>
            <Text>
                ท่านได้ตกลงยอมรับว่าเนื้อหาสาระ ข้อมูล รูปภาพหรือความคิดใดๆ ของท่านในแพลตฟอร์มนี้ ไม่ว่าโดยลักษณะใด จะได้รับการปฏิบัติดังเช่น สิ่งที่ไม่เป็นความลับและไม่มีเจ้าของ และอาจถูกเผยแพร่หรือใช้โดย หรือบริษัทที่เกี่ยวข้อง หรือบริษัทในเครือ เพื่อวัตถุประสงค์ใดก็ตาม รวมถึงแต่ ไม่จำกัดเฉพาะ การสร้างใหม่ การส่ง การตีพิมพ์ การเผยแพร่ การประกาศ การพัฒนา การผลิต หรือการทำการตลาดต่อผลิตภัณฑ์ โดยไม่คำนึงถึงสิ่งที่กล่าวมาข้างต้น ข้อมูลส่วนบุคคลใดที่ส่งให้แก่เราจะได้รับการดูแลตามนโยบายความลับของเราไม่ต้องรับผิดชอบใดๆ
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>9.การเปิดเผยข้อมูลส่วนบุคคล</Text>
            <Text>
            เราจะไม่จัดสรรหรือขายข้อมูลส่วนบุคคลของท่านให้แก่บุคคลภายนอกอื่น เพื่อวัตถุประสงค์ในการนำไปใช้โดยอิสระ นอกจากนี้ เราจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่องค์กรอื่นใด เว้นแต่ ท่านได้ร้องขอและให้อำนาจแก่เราหรือ การเปิดเผยข้อมูลนั้นเป็นไปตามที่กฎหมายอนุญาตหรือเป็นไปตามที่กฎหมายต้องการ ตัวอย่างเช่น เราอาจได้รับการร้องขอให้ทำการเปิดเผยข้อมูลเกี่ยวกับนักศึกษาเราตามคำสั่งศาล หรือตามหมายศาล นอกจากนี้ เรายังอาจได้รับการร้องขอให้ทำการเปิดเผยข้อมูลของนักศึกษา แก่องค์กรผู้มีอำนาจของรัฐ ที่กฎหมายได้ให้อำนาจไว้ หรือเราอาจทำความตกลงไว้กับบุคคลภายนอก ในการที่จะพัฒนาและบำรุงรักษาระบบการให้บริการของแพลตฟอร์ม ซึ่งบุคคลภายนอกที่เข้ามาดำเนินงานให้กับเราหรือเข้ามาดำเนินการในนามของเรานั้น จะต้องตกลงที่จะรักษาข้อมูลนักศึกษาของเราไว้เป็นความลับด้วยเช่นกัน อีกทั้งยังต้องผูกผันต่อกฎหมายที่มีผลใช้บังคับด้วย เมื่อใดก็ตามที่เราได้ว่าจ้างองค์กรอื่นใด เข้ามาให้การสนับสนุนการบริการของเรา องค์กรเหล่านั้นจะต้องปฎิบัติตาม มาตรฐานการรักษาข้อมูลเป็นความลับของเราด้วยเช่นกัน
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>10.การรวบรวมและการสงวนข้อมูลส่วนบุคคล</Text>
            <Text>
                ข้อมูลที่เกี่ยวข้องกับท่านนั้น จะถูกนำไปใช้เพื่อวัตถุประสงค์ในการดำเนินงานของเรา อย่างถูกต้องตามกฎหมายเท่านั้น ได้แก่การให้บริการที่ดีที่สุด และนำไปใช้เพื่อการประเมิน  ตลอดจนข้อเสนอต่างๆ ซึ่งเป็นไปตามความต้องการของท่าน ข้อมูลของท่านจะไม่ถูกนำไปใช้ , เก็บรวบรวม, หรือสงวนไว้ หากเราไม่มีวัตถุประสงค์ในการดำเนินการดังกล่าว เราจะเก็บรวบรวมข้อมูลส่วนบุคคลโดยการขอข้อมูลจากท่านโดยตรง โดยกระบวนการสมัคร หากท่านเลือกที่จะให้ข้อมูลส่วนบุคคล เช่น ที่อยู่ ไปรษณีย์อิเล็คทรอนิคส์ เบอร์โทรศัพท์หรือเบอร์โทรสารของท่านแก่เราแล้ว เราจะรักษาข้อมูลเหล่านั้นไว้เป็นความลับ ตามเกณฑ์มาตรฐานสำหรับการรักษาข้อมูลเป็นความลับของเรา
            </Text>
        </Box>
    </Stack>
}

const ContentBodyPrivacy = (props:any) => {
    return <Stack spacing='4'>
        <Box>
            <Text>
                นโยบายความเป็นส่วนตัวนี้ จัดทำขึ้นโดย บริษัท สเปซบี จำกัด, บริษัทเคารพสิทธิส่วนบุคคลและให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของนักศึกษา บริษัทจึงได้จัดทำนโยบายความเป็นส่วนตัวนี้ขึ้น เพื่อแจ้งแก่ท่านว่า บริษัทมีวิธีปฏิบัติในการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเพื่อนำไปใช้หรือเปิดเผยอย่างไร โดยมีวัตถุประสงค์ใดบ้าง และมีวิธีการจัดการข้อมูลส่วนบุคคลอย่างไร ตลอดจนสิทธิตามกฎหมายของท่านที่เกี่ยวข้องกับข้อมูลส่วนบุคคลด้วย ทั้งนี้ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                นโยบายความเป็นส่วนตัวนี้ครอบคลุมการให้บริการต่าง ๆ ของบริษัท ทั้งทางแพลตฟอร์ม โซเชียลมีเดียและช่องทางอื่น ๆ แก่นักศึกษา ท่านยอมรับว่า การที่ท่านใช้บริการแพลตฟอร์มหรือการให้ข้อมูลกับบริษัท ถือว่าท่านได้ยอมรับวิธีปฏิบัติของบริษัทตามที่ระบุในนโยบายความเป็นส่วนตัวนี้แล้ว 
            </Text>
        </Box>
        <Box>
            <Text fontWeight={'bold'}>ข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม</Text>
            <UnorderedList>
                <ListItem>ข้อมูลเกี่ยวกับบุคคล เช่น ชื่อ-นามสกุล, หมายเลขโทรศัพท์, อีเมล, ไอดีไลน์, IP address, Cookie ID, ข้อมูลเบราว์เซอร์และข้อมูลอื่น ๆ เกี่ยวกับอุปกรณ์ที่ท่านใช้เพื่อเข้าถึงเว็บไซต์ </ListItem>
                <ListItem>ข้อมูลเสียง ภาพ หรือข้อมูลอิเล็กทรอนิกส์ของนักศึกษา</ListItem>
            </UnorderedList>
        </Box>
        <Box>
            <Text>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เป็นระยะเวลาเท่าที่จำเป็นเพื่อการดำเนินการตามวัตถุประสงค์ที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้ให้เสร็จสิ้น เว้นแต่กรณีที่กฎหมายกำหนดหรืออนุญาตให้เก็บรักษาข้อมูลไว้นานกว่า ซึ่งอาจมีกำหนดประมาณ 5 – 10 ปี หรือเกินกว่านั้นเท่าที่จำเป็น เช่น ตามอายุความที่กฎหมายกำหนดสำหรับเรื่องที่เกี่ยวข้อง เพื่อการดำเนินคดี หรือเพื่อการตรวจสอบของหน่วยงานที่กำกับดูแล
            </Text>
            <Text>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลต่อบุคคลใดโดยไม่ได้รับความยินยอมจากท่านก่อน อย่างไรก็ดี ท่านรับทราบและยินยอมว่า เพื่อประสิทธิภาพในการให้บริการหรือเพื่อปฏิบัติตามกฎหมาย บริษัทอาจเปิดเผยข้อมูลส่วนบุคคลของท่าน โดยในการเปิดเผยข้อมูลส่วนบุคคลให้แก่บุคคลที่สาม บริษัทจะดำเนินการให้บุคคลเหล่านั้นเก็บรักษาข้อมูลส่วนบุคคลของผู้ใช้บริการไว้เป็นความลับ และไม่นำไปใช้เพื่อวัตถุประสงค์อื่นนอกเหนือจากขอบเขตที่บริษัทได้กำหนดไว้ รวมถึงในกรณีที่มีการร้องขอให้เปิดเผยข้อมูลโดยอาศัยอำนาจตามกฎหมาย อาทิ การร้องขอข้อมูลเพื่อการฟ้องร้องหรือดำเนินคดีตามกฎหมาย หรือเป็นการร้องขอจากหน่วยงานเอกชน หรือบุคคลภายนอกอื่น ๆ ที่มีความเกี่ยวข้องกับกระบวนการทางกฎหมาย รวมถึงในกรณีที่มีความจำเป็นตามสมควรในการบังคับใช้ข้อตกลงและเงื่อนไขการใช้บริการของบริษัท บริษัทอาจถ่ายโอนข้อมูลส่วนบุคคลของผู้ใช้บริการ ไม่ว่าทั้งหมดหรือบางส่วนที่บริษัทเก็บรวบรวมไว้ไปยังหน่วยงานที่เกี่ยวข้อง 
            </Text>
        </Box>
    </Stack>
}

const SignUpForm = (props: any) => {
    const navigate = useNavigate();
    const [modalTitle, setModalTitle] = useState<string>();
    const [confirmPassword, setConfirmPassword] = useState<string>();
    const {register, handleSubmit, formState: {errors}, watch} = useForm<FormValues>();
    const [btnLoading, setBtnLoading] = useState<boolean>(false);
    const [captchaToken, setCaptchaToken] = useState<string>('');
    const MySwal = withReactContent(Swal);
    const confirmPasswordRef = React.useRef<HTMLInputElement>(null);
    const reCaptchaRef = React.useRef<any>(null);
    const reCaptchaChange = (token:any) => {
        setCaptchaToken(token);
    }
    const onSubmit = handleSubmit(async (data: FormValues) => {
        setBtnLoading(true);
        var checkPassword = validatePassword(data.password, confirmPassword);
        if (!checkPassword.status) {

            MySwal.fire({
                title: 'สมัครสมาชิกไม่สำเร็จ',
                html: checkPassword.message,
                icon: 'error',
                confirmButtonText: "ตกลง",
                timer: 3000,
                didClose: () => {
                    if (confirmPasswordRef.current) {
                        confirmPasswordRef.current.focus();
                    }
                }
            })
            setBtnLoading(false);
            return false;
            // return false;
        }

        let name = `${data.firstName}  ${data.lastName}`;
        data.credit = 4;
        data.type = "student";

        const regis: any = await registerWithEmailAndPassword(name, data.email, data.password, data);
        if (!regis.status) {
            const {error} = regis;
            if (error.code === "auth/email-already-in-use") {
                MySwal.fire({
                    title: 'สมัครสมาชิกผิดพลาด',
                    html: "เนื่องจากมีอีเมล์นี้ในระบบอยู่แล้ว กรุณาเข้าสู่ระบบ",
                    icon: 'error',
                    timer: 3000,
                    didClose() {
                        // console.log("Hello World")
                    },
                })
            }
            setBtnLoading(false);
        } else {
            MySwal.fire({
                title: 'สมัครสมาชิกสำเร็จแล้ว',
                icon: 'success',
                timer: 3000,
                didClose() {
                    // navigate("/app", { replace: true });
                },
            })
            setBtnLoading(false);
        }

    });

    const mdPrivacy = useDisclosure();
    const mdAgreement = useDisclosure();

    const modalOpen = (title: string, mdOpen: any) => {
        setModalTitle(title);
        mdOpen()
    }

    const handleCFPassowrdChange = (e: any) => {
        setConfirmPassword(e.target.value)
    }

    useEffect(() => {
    }, [])

    const formatNumber = (e:React.KeyboardEvent<HTMLInputElement>, setValue:any) => {
        var ASCIICode = (e.which) ? e.which : e.keyCode;
        if (ASCIICode > 46 && (ASCIICode < 48 || ASCIICode > 57) && (ASCIICode < 96 || ASCIICode > 105)) {
            e.preventDefault();
        } else {
            if(setValue) setValue(e.currentTarget.value);
        }
    }

    return (
        <Box>
            <Stack spacing="6">
                <form name='form1' id='form1' onSubmit={onSubmit}>
                    <Stack spacing="3">
                        <FormControl>
                            <FormLabel htmlFor="name" fontSize='md' fontWeight='semibold'>ชื่อ-นามสกุล</FormLabel>
                            <Stack direction={{base: 'column', sm: 'column', md: 'row'}}>
                                <Box>
                                    <Input id="firstName"
                                           type="text"
                                           placeholder="ชื่อ"
                                           {...register("firstName", {required: "กรุณากรอกชื่อ"})}
                                    />
                                    <p style={{color: "red"}}>{errors.firstName?.message}</p>
                                </Box>
                                <Box>
                                    <Input
                                        id="lastName"
                                        type="text"
                                        placeholder="นามสกุล"
                                        {...register("lastName", {required: "กรุณากรอกนามสกุล"})}
                                    />
                                    <p style={{color: "red"}}>{errors.lastName?.message}</p>
                                </Box>

                            </Stack>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="email" fontSize='md' fontWeight='semibold'>อีเมล</FormLabel>
                            <Input id="email"
                                   type="email"
                                   placeholder="teacher@uniclass.io"
                                   {...register("email", {required: "กรุณากรอกอีเมล"})}
                            />
                            <p style={{color: "red"}}>{errors.email?.message}</p>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="password" fontSize='md' fontWeight='semibold'>รหัสผ่าน</FormLabel>
                            <Input id="password2"
                                   type="password"
                                   placeholder='รหัสผ่าน (จำนวนตัวอักษรขั้นต่ำ 8 ตัวอักษร)'
                                   {...register("password", {
                                       required: "กรุณากรอกรหัสผ่าน",
                                       minLength: {value: 8, message: "จำนวนตัวอักษรขั้นต่ำ 8 ตัวอักษร"}
                                   })}
                            />
                            <p style={{color: "red"}}>{errors.password?.message}</p>
                            {/*<FormHelperText color="muted">จำนวนตัวอักษรขั้นต่ำ 8 ตัวอักษร</FormHelperText>*/}
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor='confirmPassword' fontSize='md'
                                       fontWeight='semibold'>ยืนยันรหัสผ่าน</FormLabel>
                            <Input
                                id='confirmPassword'
                                type='password'
                                placeholder="ยืนยันรหัสผ่าน"
                                defaultValue={confirmPassword}
                                ref={confirmPasswordRef}
                                onChange={handleCFPassowrdChange}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="phone" fontSize='md' fontWeight='semibold'>เบอร์ติดต่อ</FormLabel>
                            <Input id="phone"
                                   type='text'
                                   placeholder="011-111-1111"
                                   {...register("phone", {required: "กรุณากรอกเบอร์ติดต่อ"})}
                                   onKeyDown={(e) => formatNumber(e, '')}
                            />
                            <p style={{color: "red"}}>{errors.phone?.message}</p>
                        </FormControl>

                        <FormControl>
                            <Stack>
                                <FormLabel htmlFor="school" fontSize='md' fontWeight='semibold'>มหาวิทยาลัย</FormLabel>
                                <Select
                                    placeholder='กรุณาเลือกมหาวิทยาลัย'
                                    style={{color: "black"}}
                                    {...register("school", {required: "กรุณาเลือกมหาวิทยาลัย"})}
                                >
                                    {
                                        schoolList &&
                                        schoolList.map((val: DDLCenterModel, idx: number) => {
                                            return <option key={idx} value={val.value}>{val.text}</option>
                                        })
                                    }
                                </Select>
                                <p style={{color: "red"}}>{errors.school?.message}</p>
                            </Stack>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="branch" fontSize='md' fontWeight='semibold'>สาขาวิชา</FormLabel>
                            <Select
                                placeholder='กรุณาเลือกสาขาวิชา'
                                style={{color: "black"}}
                                {...register("branch", {required: "กรุณาเลือกสาขาวิชา"})}
                            >
                                {
                                    branchList &&
                                    branchList.map((val: DDLCenterModel, idx: number) => {
                                        return <option key={idx} value={val.value}>{val.text}</option>
                                    })
                                }
                            </Select>
                            <p style={{color: "red"}}>{errors.branch?.message}</p>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="year" fontSize='md' fontWeight='semibold'>ชั้นปี</FormLabel>
                            <RadioGroup>
                                <Stack spacing='2' direction={{base:'column', md:'row'}}>
                                    {
                                        yearList &&
                                        yearList.map((val: DDLCenterModel, idx: number) => {
                                            return <Radio key={idx}
                                                          value={val.value} {...register('year', {required: 'กรุณาเลือกชั้นปี'})}>
                                                {val.text}
                                            </Radio>
                                        })

                                    }
                                </Stack>
                            </RadioGroup>
                            <Text color="red">{errors.year?.message}</Text>
                        </FormControl>
                        <Flex>
                            <Checkbox {...register("role", {required: "กรุณาอ่านและยอมรับข้อตกลงในการใช้งาน"})}>
                            </Checkbox>
                            <Text fontSize='md' paddingLeft={2}>
                                ฉันยอมรับ
                                <ChakraLink onClick={() => modalOpen("ข้อกำหนดและเงื่อนไขในการใช้บริการ", mdAgreement.onOpen)}
                                            color='blue.500'>ข้อตกลงการใช้บริการ</ChakraLink>
                                และ
                                <ChakraLink onClick={() => modalOpen("นโยบายความเป็นส่วนตัว (Privacy Policy)", mdPrivacy.onOpen)}
                                            color='blue.500'>นโยบายความเป็นส่วนตัว</ChakraLink>
                            </Text>
                        </Flex>
                        <p style={{color: "red"}}>{errors.role?.message}</p>
                        
                        <Button
                            isLoading={btnLoading} 
                            loadingText="กำลังตรวจสอบ..." 
                            colorScheme='twitter' 
                            fontSize='xl' 
                            type='submit'
                        >สมัคร</Button>
                    </Stack>

                    <ModalBegin
                        isOpen={mdAgreement.isOpen}
                        onOpen={mdAgreement.onOpen}
                        onClose={mdAgreement.onClose}
                        Title={modalTitle}
                        contentBody={<ContentBodyAgreement />}
                        contentFooter={
                            <Button colorScheme='red' onClick={mdAgreement.onClose}>
                                ตกลง
                            </Button>
                        }
                    />
                    <ModalBegin
                        isOpen={mdPrivacy.isOpen}
                        onOpen={mdPrivacy.onOpen}
                        onClose={mdPrivacy.onClose}
                        Title={modalTitle}
                        contentBody={<ContentBodyPrivacy />}
                        contentFooter={
                            <Button colorScheme='red' onClick={mdPrivacy.onClose}>
                                ตกลง
                            </Button>
                        }
                    />
                </form>
            </Stack>
            {
                props.test &&
                <>
                    <Flex align="center">
                        <Divider/>
                        <Text padding={2} minW={'fit-content'}>หรือ</Text>
                        <Divider/>
                    </Flex>
                    <Button
                        variant="secondary"
                        leftIcon={<GoogleIcon boxSize="5"/>}
                        iconSpacing="3"
                    >
                        เข้าสู่ระบบด้วย Google
                    </Button>
                </>
            }

        </Box>
    )
}

export default Index;
